import type { FormField } from '@kfolks/types'

/**
 * Mirror of `RequestService.shouldSkipByCondition` (backend) so the form
 * renderer hides fields whose conditions are not satisfied. AND semantics:
 * every declared condition must hold.
 *
 * Keeping this client-side avoids a round-trip per keystroke while staying
 * aligned with the validator the backend runs at submit-time.
 */
export function shouldSkipByCondition(field: FormField, formData: Record<string, unknown>): boolean {
	if (!field.conditions || field.conditions.length === 0) return false
	for (const c of field.conditions) {
		const other = formData[c.field]
		switch (c.operator) {
			case 'equals':
				if (other !== c.value) return true
				break
			case 'not_equals':
				if (other === c.value) return true
				break
			case 'contains':
				if (typeof other !== 'string' || typeof c.value !== 'string' || !other.includes(c.value)) return true
				break
			case 'not_empty':
				if (other === undefined || other === null || other === '') return true
				break
		}
	}
	return false
}
